/**
 * Azure Edge CDN-hosted script is used to load the contact form on the contact page. 
 * This file is intended to contain any customizations or overrides 
 * related to that script, such as custom styling or behavior for the form.
 */
export default function initAzureEdge() {
    const azureEdgeForm = document.getElementById('azureEdgeForm');

    if (azureEdgeForm) {
        console.log('%c +GF+ : SWUP Load : Azure Edge Form Created', 'font-weight: bold; background-color: #00629B; padding: 2px 2px 2px 0;');

        const formId = azureEdgeForm.dataset.gfId;
        const formApiUrl = azureEdgeForm.dataset.gfApiUrl;
        const cachedFormUrl = azureEdgeForm.dataset.gfCachedUrl;

        azureEdgeForm.appendChild(d365mktforms.createForm(
            formId,
            formApiUrl,
            cachedFormUrl
        ));
    }
}